import {durationUnits} from 'utilities/helper/durationUnitsOption';

export const initialValues: IAuctionInitialValues = {
  price: '',
  duration: '',
  duration_unit: durationUnits[0].value?.toString(),
};
export const initialValuesCreator = (
  productDetail?: IGetPostDetail,
  postEditDetail?: IPostEditDetail,
): IAuctionInitialValues => {
  return {
    price: String(productDetail?.price) || '',
    duration: String(postEditDetail?.duration) || '',
    duration_unit:
      postEditDetail?.duration_unit || durationUnits[0].value?.toString(),
  };
};
